export enum ServiceEvent {
  SyncServiceRoute = 'syncServiceRoute',
}

export enum WindowEvent {
  PermissionChange = 'PermissionChangeEvent',
  SiteTabBadge = 'SiteTabBadge',
}
